import * as React from "react";
const SvgPlusCircleFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm1-10V5H9v4H5v2h4v4h2v-4h4V9h-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgPlusCircleFill20Px;
